import styled from 'styled-components';

const SecondaryText = styled.span`
  color: ${props => props.theme.colors.textSecondary};
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  margin-top: 10px;
`;

export default SecondaryText;
